import { AccessBoundary } from '@/features/access/AccessBoundary';
import { Outlet } from 'react-router';

import { Header } from '@/components/layout/Header';
import { HeaderActionsProvider } from '@/components/layout/HeaderActions';
import { Sidebar } from '@/components/layout/Sidebar';
import './AppLayout.css';

/**
 * Gabarit connecté : en-tête permanent et navigation latérale indépendante.
 *
 * Distinct d'`AuthLayout` (connexion, plein écran, sans navigation) : les deux
 * n'ont ni la même structure ni le même public. Les mélanger obligerait à
 * masquer conditionnellement l'en-tête, source classique de scintillement au
 * changement de route.
 */
export const AppLayout = ({ contentMode = 'page' }: { contentMode?: 'page' | 'workspace' }) => (
  <HeaderActionsProvider>
    <div className={`platform-layout platform-layout--${contentMode}`}>
      <Header />
      <Sidebar />
      <main className="platform-content">
        <AccessBoundary>
          <Outlet />
        </AccessBoundary>
      </main>
    </div>
  </HeaderActionsProvider>
);
